export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de": {
        "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Woran erkennst du das?"])}
      },
      "en": {
        "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How do you know?"])}
      }
    }
  })
}
